import { MapPin, Phone, ShieldCheck } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { LeadForm } from "../components/LeadForm";
import { SITE } from "../config";
import { trackEvent } from "../analytics";

const TITLE = "Contact Atlanta Enclave Shilphata | Book Site Visit";
const DESC =
    "Contact Atlanta Enclave Shilphata – call +91 88798 56585 for price, floor plans & site visits. RERA P51700077788. Opp. Dutta Mandir, Kalyan Shilphata, Thane.";

const JSON_LD = [
    {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: TITLE,
        url: "https://atlantaenclave.com/contact/",
        description: DESC,
        isPartOf: { "@type": "WebSite", name: "Atlanta Enclave", url: "https://atlantaenclave.com/" },
    },
];

export default function Contact() {
    return (
        <div data-testid="contact-page">
            <Seo title={TITLE} description={DESC} path="/contact/" jsonLd={JSON_LD} />
            <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Contact" }]} />

            <section className="container-x mt-8">
                <Reveal>
                    <p className="eyebrow">We&apos;re Here to Help</p>
                    <h1 className="font-display mt-3 max-w-3xl text-4xl font-medium leading-[1.1] text-[#23231f] sm:text-5xl">
                        Contact Atlanta Enclave Shilphata
                    </h1>
                    <p className="mt-5 max-w-2xl text-sm leading-relaxed text-[#55534a] sm:text-base">
                        Ready to make Atlanta Enclave Shilphata your home? Call us or send a message — our team will assist you
                        with the latest price, floor plans, brochure and site visit scheduling.
                    </p>
                </Reveal>

                <div className="mt-10 grid items-start gap-10 lg:grid-cols-2">
                    <Reveal>
                        <div className="grid gap-4">
                            <div className="card-line flex items-start gap-4 p-5">
                                <MapPin size={20} className="mt-0.5 shrink-0 text-[#8f7f45]" />
                                <div>
                                    <p className="text-sm font-bold text-[#23231f]">Site Address</p>
                                    <p className="mt-1 text-sm leading-relaxed text-[#55534a]" data-testid="contact-address">{SITE.address}</p>
                                </div>
                            </div>
                            <div className="card-line flex items-start gap-4 p-5">
                                <Phone size={20} className="mt-0.5 shrink-0 text-[#8f7f45]" />
                                <div>
                                    <p className="text-sm font-bold text-[#23231f]">Call Us</p>
                                    <p className="mt-1 text-sm text-[#55534a]">
                                        <a href={SITE.phoneTel} onClick={() => trackEvent("call_click", { placement: "contact_page" })} className="font-bold text-[#23231f] hover:text-[#6e6234]" data-testid="contact-phone-link">
                                            {SITE.phoneDisplay}
                                        </a>
                                    </p>
                                    <a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent("whatsapp_click", { placement: "contact_page" })} className="mt-1 inline-block text-sm font-semibold text-[#178a45] underline underline-offset-2" data-testid="contact-whatsapp-link">
                                        Chat on WhatsApp
                                    </a>
                                </div>
                            </div>
                            <div className="card-line flex items-start gap-4 p-5">
                                <ShieldCheck size={20} className="mt-0.5 shrink-0 text-[#8f7f45]" />
                                <div>
                                    <p className="text-sm font-bold text-[#23231f]">RERA</p>
                                    <p className="mt-1 text-sm text-[#55534a]">
                                        MahaRERA Registration No: <strong>{SITE.rera}</strong> —{" "}
                                        <a href={SITE.reraPortal} target="_blank" rel="noopener noreferrer" className="font-semibold text-[#6e6234] underline underline-offset-2" data-testid="contact-rera-link">
                                            maharera.mahaonline.gov.in
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Reveal>
                    <Reveal delay={120}>
                        <LeadForm source="contact_page" idPrefix="contact" heading="Send Us a Message" />
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
